/**
 * O que faz: Lê apenas uma página de contatos e interrompe leituras abandonadas.
 * Onde usa: Detalhes do dashboard; paginação por timestamp+ID.
 * Conexões: React Query e get_dashboard_contatos_v1.
 * Tabelas: SELECT de campos pessoais mínimos de leads, somente após abrir detalhe autenticado.
 * Data: 31/08/2026.
 */
import { useQuery } from '@tanstack/react-query';
import type { ContextoDashboard, FiltroContatosDashboard, PaginaContatosDashboard } from '@/features/dashboard/data/dashboardContracts';
import { buscarContatosDashboard } from '@/services/dashboardResumoService';
import { chaveContextoDashboard } from './useDashboardConsultas';

export function useContatosDashboard(contexto: ContextoDashboard | undefined, filtro: FiltroContatosDashboard,
  cursor: PaginaContatosDashboard['proximoCursor'], tamanho: 20 | 50 | 100, aberto: boolean) {
  return useQuery({
    queryKey: ['dashboard-v1', ...chaveContextoDashboard(contexto), 'contatos', contexto?.periodo, filtro, cursor, tamanho],
    queryFn: ({ signal }) => buscarContatosDashboard(contexto!, filtro, cursor, tamanho, signal),
    // Sem placeholder: trocar origem ou clínica nunca exibe contatos da consulta anterior.
    enabled: !!contexto && aberto, staleTime: 60_000, gcTime: 60_000, retry: 1, refetchOnWindowFocus: false,
  });
}
